import {Suspense, lazy} from 'react'
import Loader from "../customs/loader/main"

const Main = lazy(() => import("../components/outstandingPayment/nominationOutstandingPayment"))

const NominationOutstandingPayment = () => {
  return (
    <Suspense fallback={<Loader />}> 
        <Main />
    </Suspense>
  )
}

export default NominationOutstandingPayment